import {
  FETCH_ACCOUNT_TAGS,
  SET_ACCOUNT_TAGS_ERRORED,
  SET_ACCOUNT_TAGS_FETCHING,
  CREATE_TAG,
  DELETE_TAG,
  EDIT_TAG,
  UPDATE_TAGS_MANAGEMENT_STATE,
  REPLACE_ACCOUNT_TAGS,
} from 'constants/account/tags';

export const fetchAccountTags = () => ({
  type: FETCH_ACCOUNT_TAGS,
});

export const setAccountTagsFetching = () => ({
  type: SET_ACCOUNT_TAGS_FETCHING,
});

export const replaceAccountTags = data => ({
  type: REPLACE_ACCOUNT_TAGS,
  payload: data,
});

export const setAccountTagsErrored = error => ({
  type: SET_ACCOUNT_TAGS_ERRORED,
  payload: { error },
});

export function createTag(tagName) {
  return {
    type: CREATE_TAG,
    payload: {
      tagName,
    },
  };
}

export function deleteTag(tagId) {
  return {
    type: DELETE_TAG,
    payload: {
      tagId,
    },
  };
}

export function editTag(tagId, tagName) {
  return {
    type: EDIT_TAG,
    payload: {
      tagId,
      newTagName: tagName,
    },
  };
}

export function updateTagsManagementState(errorMessage, successMessage) {
  return {
    type: UPDATE_TAGS_MANAGEMENT_STATE,
    payload: {
      errorMessage,
      successMessage,
    },
  };
}
